export default '/static/images/onevision/login-image-ov.jpg';
